import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import { color, spacing, typography } from '@decisiv/design-tokens';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import { P } from '@decisiv/ui-components/lib/components/Typography';

// ErrorLogLookup

export const ResultsHeader = styled(Flex)`
  border-bottom: 1px solid ${toColorString(color.base.halfMoon)};
`;

// EventList

export const ListContainer = styled.div`
  border: 1px solid ${toColorString(color.base.halfMoon)};
  border-radius: 4px;
  overflow: hidden;
`;

export const ExpandBar = styled(Flex)`
  background-color: ${toColorString(color.base.fullMoon)};
  cursor: pointer;
  user-select: none;
  transition: background-color 150ms ease;

  &:hover {
    background-color: ${toColorString(color.base.halfMoon)};
  }
`;

// EventRow

export const RowContainer = styled.div`
  border-left: 3px solid ${(props) => toColorString(props.$borderColor)};
  background-color: ${(props) =>
    props.$isAnchor
      ? toColorString(color.status.warning.light)
      : toColorString(color.base.snowWhite)};
  cursor: pointer;
  transition: background-color 150ms ease;

  &:hover {
    background-color: ${(props) =>
      props.$isAnchor
        ? toColorString(color.status.warning.light)
        : toColorString(color.base.fullMoon)};
  }

  border-top: 1px solid ${toColorString(color.base.halfMoon)};
`;

export const SummaryLine = styled(Flex)`
  font-family: ${typography.typeface.mono};
  font-size: 13px;
  line-height: 1.4;
  min-height: ${spacing.base * 3.5}px;
`;

export const Timestamp = styled.span`
  color: ${toColorString(color.base.alaskanHusky)};
  white-space: nowrap;
  margin-right: ${spacing.base}px;
  flex-shrink: 0;
`;

export const LevelBadge = styled.span`
  color: ${(props) => toColorString(props.$color)};
  font-weight: ${typography.weight.alias.semibold};
  font-size: 11px;
  white-space: nowrap;
  margin-right: ${spacing.base}px;
  flex-shrink: 0;
  min-width: 42px;
`;

export const HttpInfo = styled.span`
  color: ${toColorString(color.base.blackSheep)};
  white-space: nowrap;
  margin-right: ${spacing.base}px;
  flex-shrink: 0;
`;

export const ControllerAction = styled.span`
  color: ${toColorString(color.interaction.pacificOcean)};
  white-space: nowrap;
  margin-right: ${spacing.base}px;
  flex-shrink: 0;
`;

export const PathText = styled.span`
  color: ${toColorString(color.base.alaskanHusky)};
  white-space: nowrap;
  margin-right: ${spacing.base}px;
  flex-shrink: 0;
  max-width: ${spacing.base * 30}px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MessageText = styled.span`
  color: ${toColorString(color.base.charcoal)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
`;

export const DetailContainer = styled.div`
  border-top: 1px solid ${toColorString(color.base.halfMoon)};
  padding: ${spacing.base * 1.5}px;
  background-color: ${toColorString(color.base.fullMoon)};
`;

export const JsonBlock = styled.pre`
  font-family: ${typography.typeface.mono};
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
  padding: ${spacing.base}px;
  background-color: ${toColorString(color.base.snowWhite)};
  border: 1px solid ${toColorString(color.base.halfMoon)};
  border-radius: 4px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: ${spacing.base * 40}px;
  overflow-y: auto;
`;

export const BacktraceBlock = styled.pre`
  font-family: ${typography.typeface.mono};
  font-size: 12px;
  line-height: 1.6;
  margin: 0;
  padding: ${spacing.base}px;
  background-color: ${toColorString(color.base.snowWhite)};
  border: 1px solid ${toColorString(color.status.danger.light)};
  border-left: 3px solid ${toColorString(color.status.danger.medium)};
  border-radius: 4px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  color: ${toColorString(color.base.blackSheep)};
`;

export const SectionLabel = styled(P)`
  font-weight: ${typography.weight.alias.semibold};
`;

export const SyntaxStyles = styled.div`
  .json-key {
    color: ${toColorString(color.interaction.pacificOcean)};
  }
  .json-string {
    color: ${toColorString(color.status.success.dark)};
  }
  .json-number {
    color: ${toColorString(color.status.warning.dark)};
  }
  .json-boolean {
    color: ${toColorString(color.visualInterest.koolaidCake.medium)};
  }
  .json-null {
    color: ${toColorString(color.base.alaskanHusky)};
  }
`;
